import { createContext, type CSSProperties, type ReactNode } from "react";
import type { ModalProps } from "components/ui/v2/modal";

type LegacyModalProps = Partial<Omit<ModalProps, "open" | "onClose" | "children">> & {
  full?: boolean;
  style?: CSSProperties;
  width?: number | string;
  height?: number | string;
};

export interface IOpenModal extends LegacyModalProps {
  modalComponent: JSX.Element;
  onOpenModal?: () => void;
  onCloseModal?: () => void;
  hideCloseButton?: boolean;
}

interface IModalMethods {
  openModal: (params: IOpenModal) => void;
  closeModal: () => void;
  setModalComponent: (newModalComponent: JSX.Element) => void;
  /** Publish footer into the provider Modal slot (used by onFooterChange). */
  setModalFooter: (footer: ReactNode) => void;
}

const modalMethods = {
  openModal: () => null,
  closeModal: () => null,
  setModalComponent: () => null,
  setModalFooter: () => null,
};

export const ModalContext = createContext<IModalMethods>(modalMethods);
